import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { sanitizeUploadFilename } from 'src/utils/upload-filename';

const baseUrl = process.env.REACT_APP_API_URL;

export async function smallBannersUploadByServer(
  file: File,
  options: {
    uploadUrl: string;
    fileType?: string;
    tags?: string;
    pathPrefix?: string;
    customFilename?: string;
  }
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', options?.fileType || 'IMAGE');
  formData.append('tags', options?.tags || 'small-banners');
  formData.append('pathPrefix', options?.pathPrefix || 'small-banners');
  formData.append('customFilename', sanitizeUploadFilename(options?.customFilename || file.name));

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
    Accept: 'application/json',
  };
  const url = `${baseUrl}/small-banners/upload`;
  const response = await axios.post<any>(url, formData, { headers });
  return response.data;
}
